if($('.js-accordion').length){
	$('.js-accordion').click(function(){
		$(this).toggleClass('is-open');
		$(this).next('.js-accordion-content').slideToggle(250, 'swing').toggleClass('-open');
	})
}
